import FixAppointment from "../Components/FixAppointment";

const AppointmentPage = () => {
  return (
    <div>
      <FixAppointment />
    </div>
  );
};

export default AppointmentPage;
